<kendo-stacklayout [class]="'k-stack-layout-' + themeColor" [orientation]="orientation" [gap]="gap" [align]="align">
    <ng-content></ng-content>
</kendo-stacklayout>